export class CreditCardTechnologyValueConverter {
    toView(creditCardTechnology: number): string {
        switch (creditCardTechnology) {
        case 0:
            return "MSR";
        case 1:
            return "EMV";
        default:
            return "";
        }
    }
}
